import { jsx as _jsx } from "react/jsx-runtime";
var Thunder = function Thunder(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: /*#__PURE__*/_jsx("path", {
      d: "M6.87087 12.7997H11.9999C12.2839 12.7997 12.5549 12.9207 12.7439 13.1317C12.9329 13.3427 13.0239 13.6247 12.9939 13.9067L12.5449 18.0567L17.1289 11.1997H11.9999C11.7159 11.1997 11.4449 11.0787 11.2559 10.8677C11.0659 10.6567 10.9749 10.3747 11.0059 10.0927L11.4549 5.94374L6.87087 12.7997ZM11.1109 22.9997C10.9969 22.9997 10.8819 22.9807 10.7689 22.9397C10.3369 22.7817 10.0669 22.3497 10.1169 21.8927L10.8859 14.7997H4.99987C4.63087 14.7997 4.29187 14.5967 4.11787 14.2717C3.94387 13.9457 3.96387 13.5507 4.16887 13.2437L12.0579 1.44474C12.3129 1.06074 12.7969 0.902737 13.2299 1.06074C13.6629 1.21774 13.9329 1.65074 13.8829 2.10774L13.1139 9.19974H18.9999C19.3689 9.19974 19.7079 9.40374 19.8819 9.72874C20.0559 10.0547 20.0359 10.4487 19.8309 10.7557L11.9419 22.5557C11.7529 22.8397 11.4369 22.9997 11.1109 22.9997Z",
      fill: color
    })
  });
};
export default Thunder;